export const events = [
  {
    id: "hiroshima-20260708",
    date: "2026-07-08",
    name: "Discover Rinnai2026 in 広島",
    tableKey: "discover_rinnai_2026_hiroshima",
    seminars: [
      { id: "hiroshima-20260708-s1", label: '7/8　13：10〜　GX　ZEH-M実現へ導く要件と実務設計の最前線（３）' },
      { id: "hiroshima-20260708-s2", label: '7/8　14：30〜　"窓が変わると暮らしも変わる"　これからのマンションに最適な窓（４）' },
      { id: "hiroshima-20260708-s3", label: '7/8　15：10〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まい事例とそのポイント（２）' },
    ]
  },
  {
    id: "hiroshima-20260709",
    date: "2026-07-09",
    name: "Discover Rinnai2026 in 広島",
    tableKey: "discover_rinnai_2026_hiroshima",
    seminars: [
      { id: "hiroshima-20260709-s1", label: '7/9　10：10〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まい事例とそのポイント（２）' },
      { id: "hiroshima-20260709-s2", label: '7/9　11：20〜　GX-ZEH時代に向けた「家まるごと」自家消費制御（６）' },
      { id: "hiroshima-20260709-s3", label: '7/9　13：00〜　GX ZEHが住宅性能のスタンダードになる！？（１）' },
      { id: "hiroshima-20260709-s4", label: '7/9　14：10〜　断熱等級６の実現へ。樹脂窓が選ばれるこれだけの理由（５）' },
      { id: "hiroshima-20260709-s5", label: '7/9　14：50〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まい事例とそのポイント（２）' },
      { id: "hiroshima-20260709-s6", label: '7/9　15：00〜　GX志向型住宅とネオマフォーム（７）' },
    ]
  },
  {
    id: "sendai-20260716",
    date: "2026-07-16",
    name: "Discover Rinnai2026 in 仙台",
    tableKey: "discover_rinnai_2026_sendai",
    seminars: [
      { id: "sendai-20260716-s1", label: '7/16　10：00〜　SNSで家づくりを考える時代の“家事ラク”“省エネ”住まい事例とそのポイント' },
      { id: "sendai-20260716-s2", label: '7/16　13：30〜　SNSで家づくりを考える時代の“家事ラク”“省エネ”住まい事例とそのポイント' },
    ]
  },
  {
    id: "sendai-20260717",
    date: "2026-07-17",
    name: "Discover Rinnai2026 in 仙台",
    tableKey: "discover_rinnai_2026_sendai",
    seminars: [
      { id: "sendai-20260717-s1", label: '7/17　10：00〜　GX-ZEHが住宅性能のスタンダードになる!?' },
      { id: "sendai-20260717-s2", label: '7/17　13：30〜　GX-ZEHが住宅性能のスタンダードになる!?' },
    ]
  },
  {
    id: "fukuoka-20260716",
    date: "2026-07-16",
    name: "Discover Rinnai2026 in 福岡",
    tableKey: "discover_rinnai_2026_fukuoka",
    seminars: [
      { id: "fukuoka-20260716-s1", label: '7/16　10：30〜　GX ZEHが住宅性能のスタンダードになる！？（１）' },
      { id: "fukuoka-20260716-s2", label: '7/16　10：30〜　GX ZEH-M実現へ導く要件と実務設計の最前線（５）' },
      { id: "fukuoka-20260716-s3", label: '7/16　12：30〜　GX ZEH時代に向けた「家まるごと」自家消費制御（４）' },
      { id: "fukuoka-20260716-s4", label: '7/16　13：40〜　GX ZEHが住宅性能のスタンダードになる！？（１）' },
      { id: "fukuoka-20260716-s5", label: '7/16　14：50〜　GX ZEH-M実現へ導く要件と実務設計の最前線（５）' },
      { id: "fukuoka-20260716-s6", label: '7/16　15：30〜　省エネ×業務増で現場崩壊！？AI活用最前線（３）' },
    ]
  },
  { 
    id: "fukuoka-20260717",
    date: "2026-07-17",
    name: "Discover Rinnai2026 in 福岡",
    tableKey: "discover_rinnai_2026_fukuoka",
    seminars: [
      { id: "fukuoka-20260717-s1", label: '7/17　10：00〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まいの事例とそのポイント' },
      { id: "fukuoka-20260717-s2", label: '7/17　11：00〜　家事ストレスゼロへ。選択導線を激的に変える”NANKAI × 乾太くん”の最強タッグ' },
      { id: "fukuoka-20260717-s3", label: '7/17　11：30〜　GX ZEH時代に向けた「家まるごと」自家消費制御（４）' },
      { id: "fukuoka-20260717-s4", label: '7/17　12：40〜　2027年GX-ZEHの標準化（６）' },
      { id: "fukuoka-20260717-s5", label: '7/17　13：50〜　省エネ×業務増で現場崩壊！？AI活用最前線（３）' },
      { id: "fukuoka-20260717-s6", label: '7/17　14：20〜　家事ストレスゼロへ。選択導線を激的に変える”NANKAI × 乾太くん”の最強タッグ（７）' },
      { id: "fukuoka-20260717-s7", label: '7/17　15：30〜　SNSで家づくりを考える時代の”家事ラク””省エネ”（２）' },
    ]
  },
  {
    id: "takamatsu-20260724",
    date: "2026-07-24",
    name: "Discover Rinnai2026 in 高松",
    tableKey: "discover_rinnai_2026_takamatsu",
    seminars: [
      { id: "takamatsu-20260724-s1", label: '7/24　11：00〜　GX ZEHが住宅性能のスタンダードになる！？' },
      { id: "takamatsu-20260724-s2", label: '7/24　13：00〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まい事例とそのポイント' },
      { id: "takamatsu-20260724-s3", label: '7/24　15：00〜　GX-ZEH時代に向けた「家まるごと」自家消費制御' },
    ]
  },
  {
    id: "sapporo-20260724",
    date: "2026-07-24",
    name: "Rinnai Fair2026 in 札幌",
    tableKey: "rinnai_fair_2026_sapporo",
    seminars: [
      { id: "sapporo-20260724-s1", label: '7/24　10：30〜　全館空調を知る' },
      { id: "sapporo-20260724-s2", label: '7/24　13：30〜　驚きの床下暖房活用術' },
    ]
  },
  {
    id: "niigata-20260824",
    date: "2026-08-24",
    name: "Discover Rinnai2026 in 新潟",
    tableKey: "discover_rinnai_2026_niigata",
    seminars: [
      { id: "niigata-20260824-s1", label: '8/24　10：00〜　GX-ZEH時代に向けた「家まるごと」自家消費制御' },
      { id: "niigata-20260824-s2", label: '8/24　13：00〜　GX-ZEHが住宅性能のスタンダードになる！？' },
      { id: "niigata-20260824-s3", label: '8/24　15：00〜　GX-ZEHの標準化' },
    ]
  },
  {
    id: "niigata-20260825",
    date: "2026-08-25",
    name: "Discover Rinnai2026 in 新潟",
    tableKey: "discover_rinnai_2026_niigata",
    seminars: [
      { id: "niigata-20260825-s1", label: '8/25　10：00〜　GX-ZEH時代に向けた「家まるごと」自家消費制御' },
      { id: "niigata-20260825-s2", label: '8/25　13：00〜　SNSで家づくりを考える時代の「家事ラク」「省エネ」' },
    ]
  },
  {
    id: "matsuyama-20260911",
    date: "2026-09-11",
    name: "Discover Rinnai2026 in 松山",
    tableKey: "discover_rinnai_2026_matsuyama",
    seminars: [
      { id: "matsuyama-20260911-s1", label: '9/11　11：00〜　GX ZEHが住宅性能のスタンダードになる！？' },
      { id: "matsuyama-20260911-s2", label: '9/11　13：00〜　SNSで家づくりを考える時代の”家事ラク””省エネ”住まい事例とそのポイント' },
      { id: "matsuyama-20260911-s3", label: '9/11　15：00〜　GX-ZEH時代に向けた「家まるごと」自家消費制御' },
    ]
  },
];
